import { render, staticRenderFns } from "./emptyLogistics.vue?vue&type=template&id=825e3fae&scoped=true"
var script = {}
import style0 from "./emptyLogistics.vue?vue&type=style&index=0&id=825e3fae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "825e3fae",
  null
  
)

export default component.exports